<div class="cb-code-wrapper" [class.cb-disabled]="disabled()" [class.cb-required]="required()"
    [class.cb-error]="error()">
    @if(label() || info()){
    <div class="cb-code-label">
        @if(label()){
        <label>{{label()}}</label>
        }
        @if(info() && info()!.length>0){
        <cb-icon name="cb-base-outline-help"></cb-icon>
        }
    </div>
    }
    <div class="cb-code-container" [class.cb-uppercase]="!caseSensitive()">
        @for (input of inputs; track $index) {
        <div class="cb-code">
            <input #CodeInput [(ngModel)]="values[$index]" (paste)="onPaste($event)"
                (keydown)="inputKeydown($event, $index)" (keyup.backspace)="inputDelete($event, $index)"
                (input)="inputChanged($index)" [disabled]="disabled()" placeholder="0" [maxLength]="1"
                [mask]="(allowLetters())? 'A' : '9'" (blur)="inputBlurred($index)" />
        </div>
        }
    </div>
    @if(hint() && hint()!.length>0){
    <p class="cb-code-hint">{{hint()}}</p>
    }
</div>